export default __webpack_public_path__ + "static/media/card.634f62de.png";